/** Check if a value is a valid finite number */
export const isNum = (v: unknown): v is number =>
  typeof v === "number" && Number.isFinite(v);

/** Safely parse a number from string or number, returns undefined if not valid */
export const safeNum = (v: unknown): number | undefined => {
  const n = typeof v === "string" ? Number(v) : v;
  return Number.isFinite(n as number) ? (n as number) : undefined;
};

/** Format a number or fallback */
export const fmt = (v?: number): string =>
  typeof v === "number" ? String(v) : "-";

/** Deduplicate an array by a key function */
export function dedupeByKey<T>(arr: T[], keyFn: (t: T) => string): T[] {
  const seen = new Set<string>();
  return arr.filter((x) => {
    const k = keyFn(x);
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
